var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('fq-ignore'),_c('nuxt-link',{attrs:{"to":"/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }